// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

/**
 * Received object that we want to compare inside globalSort
 * Gets value from it using sortingKey
 * Convert value to the number if it is possible
 * Returns value
 *
 * @typedef GetItemForComparingArgs
 * @property {Object} element - Object that we comparing inside of the globalSort function
 * @property {String} sortingKey - Sorting key that will be user to get value from object in order to compare it (element[sortingKey])
 *
 * @param {Object} GetItemForComparingArgs
 *
 * @return {String || Number} - Value
 *
 * @example
 * const element = { label: 'Sydney', value: 1 }
 * const sortingKey = 'label'
 * const valueForComparison = getItemForComparing({ element, sortingKey })
 */

const getItemForComparing = ({ element, sortingKey }) => {
  let item = sortingKey ? element[sortingKey] : element

  if (!isNaN(item)) {
    return parseFloat(item)
  }

  if (typeof item === 'string') return item.toUpperCase() // Make the sort case-insensitive
  if (item === undefined) return null // This is because undefined cannot be compared for sorting
  return item
}

/**
 * Receives array of items that should be sorted
 * Gets value for comparison from each item using getItemForComparing function
 * Compares items and based on ASC value returns array sorted in ASC ot DESC order
 *
 * @typedef GlobalSortArgs
 * @property {Array} data - Array of objects that we want to sort
 * @property {String} sortingKey - Sorting key that will be user to get value from object in order to compare it
 * @property {Boolean} ASC - Boolean value that indicates in which order array will be sorted
 *
 * @param {Object} GlobalSortArgs
 *
 * @return {String} - Referral code
 *
 * @example
 * const data =  [{ label: 'Sydney', value: 1 }]
 * const sortingKey = 'label'
 * const ASC = true
 * globalSort({ data, sortingKey, ASC })
 */
export const globalSort = ({ data, sortingKey, ASC = true }) => {
  // Do not mutate the passed in array
  data = data.slice(0)
  const sortedData = data.sort((firstEl, secondEl) => {
    const firstItem = getItemForComparing({
      element: firstEl,
      sortingKey,
    })

    const secondItem = getItemForComparing({
      element: secondEl,
      sortingKey,
    })

    if (firstItem < secondItem) {
      return ASC ? -1 : 1
    }

    if (firstItem > secondItem) {
      return ASC ? 1 : -1
    }

    return 0
  })
  const otherOption = findItemIndex({
    data: sortedData,
    searchValue: 'OTHER',
    key: sortingKey,
  })

  if (otherOption !== -1) {
    const otherOptionItem = sortedData.splice(otherOption, 1)
    sortedData.push(otherOptionItem[0])
  }

  const allOption = findItemIndex({
    data: sortedData,
    searchValue: 'ALL',
    key: sortingKey,
  })

  if (allOption !== -1) {
    const allOptionItem = sortedData.splice(allOption, 1)
    sortedData.unshift(allOptionItem[0])
  }

  return sortedData
}

const findItemIndex = ({ data, searchValue, key }) => {
  if (key) {
    return data.findIndex(
      item =>
        String(item[key]).toUpperCase() === String(searchValue).toUpperCase(),
    )
  }

  return data.findIndex(
    item => String(item).toUpperCase() === String(searchValue).toUpperCase(),
  )
}
